import React from 'react';
import { customerLogos } from '../mock';

const TrustedLogos = () => {
  const doubled = [...customerLogos, ...customerLogos];
  return (
    <section className="bg-[#061c3f] py-16 lg:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-semibold text-center max-w-4xl mx-auto leading-snug">
          Trusted by 99% of the Fortune 500 and over 1 million customers worldwide
        </h2>
      </div>

      <div className="mt-12 relative no-scrollbar">
        <div className="flex gap-16 items-center marquee-track" style={{ width: 'max-content' }}>
          {doubled.map((logo, idx) => (
            <div key={idx} className="h-10 flex items-center opacity-80 hover:opacity-100 transition-opacity shrink-0">
              <img src={logo.src} alt={logo.name} className="h-8 lg:h-10 w-auto" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedLogos;
